import { createSlice } from '@reduxjs/toolkit';


export const shiftsEmployeesSlice = createSlice({
    name: 'shiftEmployees',
    initialState: {
        shift_employees: {},
        shift_employees_list: [],
        shift_employees_list_select: [],
        type_shifts_list_select: [], 
        frecuency_shifts_list_select: [],  
    },
    reducers: {
        setShiftsEmployeesListRedux: ( state, { payload } ) => {
            state.shift_employees_list  =  payload;
        },
        setShiftsEmployeesRedux: ( state, { payload } ) => {
            state.shift_employees  =  payload;
        },
        setShiftsEmployeesesSelectRedux: ( state, { payload } ) => {
            state.shift_employees_list_select  =  payload;
        },
        setTypeShiftsSelectRedux: ( state, { payload } ) => {
            state.type_shifts_list_select  =  payload;
        },
        setFrecuencyhiftsSelectRedux: ( state, { payload } ) => {
            state.frecuency_shifts_list_select  =  payload;
        }
    },
    
});


export const { setShiftsEmployeesListRedux, setShiftsEmployeesRedux, setShiftsEmployeesesSelectRedux, 
               setTypeShiftsSelectRedux, setFrecuencyhiftsSelectRedux } = shiftsEmployeesSlice.actions;